import { render } from "./InputNumeric.vue?vue&type=template&id=3ddbb3e4"
import script from "./InputNumeric.vue?vue&type=script&lang=ts"
export * from "./InputNumeric.vue?vue&type=script&lang=ts"
script.render = render

export default script